/* eslint react-hooks/exhaustive-deps: 0 */
import SignOffBar from "@/components/SignOffBar";   // Batch 11 · A2
import React, { useEffect, useState } from "react";
import api, { toErrMsg } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";
import { useEngagement } from "@/contexts/EngagementContext";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const FIELDS = [
  "related_parties_summary", "fraud_indicators", "fraud_communication",
  "fraud_effect", "noncompliance_indicators", "noncompliance_communication",
  "going_concern_summary", "going_concern_reference_209a",
  "other_practitioners_used", "other_practitioners_notes",
  "experts_used", "experts_notes",
];

export default function W175SpecificPage() {
  const { current, currentEngId } = useEngagement();
  const { t } = useI18n();
  const [state, setState] = useState(null);
  const [draft, setDraft] = useState({});
  const reload = async () => {
    if (!currentEngId) return;
    const r = await api.get(`/engagements/${currentEngId}/w17/specific`, { _silent: true });
    setState(r.data);
    const d = {}; FIELDS.forEach(f => d[f] = r.data[f] || ""); setDraft(d);
  };
  useEffect(() => { reload(); }, [currentEngId]);
  const save = async () => {
    try {
      const r = await api.post(`/engagements/${currentEngId}/w17/specific`,
                                     { patch: draft }, { _silent: true });
      setState(r.data); toast.success(t("w17_5.saved"));
    } catch (e) { toast.error(toErrMsg(e, "Failed")); }
  };
  if (!current) return <div className="text-sm text-muted-foreground">{t("common.noEng")}</div>;
  if (!state) return <div className="text-sm text-muted-foreground p-6" data-testid="w17-5-loading">{t("common.loading")}</div>;
  const isReview = (current?.engagement_type || "audit") === "review";
  if (!isReview) return <div className="p-6 text-sm text-muted-foreground" data-testid="w17-5-audit-only">{t("w17_5.notForAudit")}</div>;
  return (
    <div className="space-y-6" data-testid="w17-5-page">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight" data-testid="w17-5-title">
          <span dir="ltr" className="font-mono text-[13px] text-muted-foreground me-2">505(r)</span>
          {t("w17_5.title")}
        </h1>
        <SignOffBar itemType="w17_5" itemKey="W17.5" />   {/* Batch 11 · A2 */}
        <p className="text-sm text-muted-foreground">{t("w17_5.subtitle")}</p>
      </div>
      <Card>
        <CardHeader><CardTitle className="text-base normal-case">{t("w17_5.relatedParties")}</CardTitle></CardHeader>
        <CardContent className="space-y-2">
          <a href="/risk-assessment-forms?openForm=related_parties" className="text-[11px] text-blue-700 underline" data-testid="w17-5-link-w16">{t("w17_5.linkW16")}</a>
          <Textarea placeholder={t("w17_5.relatedPartiesPh")} value={draft.related_parties_summary || ""}
                     onChange={e => setDraft({...draft, related_parties_summary: e.target.value})}
                     className="h-16 text-[11px]" data-testid="w17-5-related-parties" />
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle className="text-base normal-case">{t("w17_5.fraudNoncompliance")}</CardTitle></CardHeader>
        <CardContent className="space-y-2">
          {["fraud_indicators", "fraud_communication", "fraud_effect", "noncompliance_indicators", "noncompliance_communication"].map(f => (
            <Textarea key={f} placeholder={t(`w17_5.${f}Ph`)} value={draft[f] || ""}
                             onChange={e => setDraft({...draft, [f]: e.target.value})}
                             className="h-16 text-[11px]" data-testid={`w17-5-${f}`} />
          ))}
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle className="text-base normal-case">{t("w17_5.goingConcern")}</CardTitle></CardHeader>
        <CardContent className="space-y-2">
          <a href="/risk-assessment-forms?openForm=going_concern_events_and_conditions" className="text-[11px] text-blue-700 underline" data-testid="w17-5-link-gc">{t("w17_5.linkGc")}</a>
          <Textarea placeholder={t("w17_5.going_concern_summaryPh")} value={draft.going_concern_summary || ""}
                     onChange={e => setDraft({...draft, going_concern_summary: e.target.value})}
                     className="h-16 text-[11px]" data-testid="w17-5-gc-summary" />
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle className="text-base normal-case">{t("w17_5.otherPractitioners")}</CardTitle></CardHeader>
        <CardContent className="space-y-2">
          {["other_practitioners_used", "other_practitioners_notes", "experts_used", "experts_notes"].map(f => (
            <Textarea key={f} placeholder={t(`w17_5.${f}Ph`)} value={draft[f] || ""}
                             onChange={e => setDraft({...draft, [f]: e.target.value})}
                             className="h-16 text-[11px]" data-testid={`w17-5-${f}`} />
          ))}
        </CardContent>
      </Card>
      <Button onClick={save} data-testid="w17-5-save">{t("w17_5.save")}</Button>
    </div>
  );
}
